import React from 'react'
import WrapperByRole, { WrapperByRoleProps } from '../components/Wrapper/WrapperByRole'

const RemoteTeacherWrapper: React.FC<WrapperByRoleProps> = (props) =>
  <WrapperByRole role='remote-teacher' {...props} />


export default RemoteTeacherWrapper